import React, {useContext, useEffect} from "react";
import {Link, Navigate} from "react-router-dom";
import {DateTime} from "luxon";
import useHeadline from "../../ui/useHeadline";
import useActionButtons from "../../ui/useActionButtons";
import {ActionButtonsContext, ClustersContext, HeadlineContext} from "../../LoggedInApp";
import {LoggedInRoutes} from "../../../LoggedInRoutes";
import LoadingDialog from "../../misc/LoadingDialog";
import AlertInfo from "../../ui/AlertInfo";
import ClusterCard from "./ClusterCard";

export default function ClustersIndexPage() {

  const {clusters, refresh} = useContext(ClustersContext);

  useHeadline(useContext(HeadlineContext),
      <h1>
        Clusters
        <small className="d-none d-md-inline">{DateTime.now().toLocaleString(DateTime.DATETIME_MED_WITH_SECONDS)}</small>
      </h1>
  )

  useActionButtons(useContext(ActionButtonsContext),
      <Link to={LoggedInRoutes.CLUSTERS.MGMT.CREATE}
            className="btn btn-primary"
            style={{marginLeft: "auto"}}>
        <i className="bx bx-plus"></i> Add <span className="d-none d-md-inline">Cluster</span>
      </Link>
  )

  useEffect(() => {
    refresh();
  }, []);

  if (!clusters) {
    return <LoadingDialog />
  }

  // With a single cluster there is nothing to choose from. Go straight to it.
  if (clusters.length === 1) {
    return <Navigate to={LoggedInRoutes.CLUSTERS.SHOW(clusters[0].uuid)} replace />
  }

  if (clusters.length === 0) {
    return <div className="mb-3"><AlertInfo>No clusters configured yet.</AlertInfo></div>
  }

  return (
      <div className="cluster-grid">
        {clusters.map((cluster) => <ClusterCard cluster={cluster} key={cluster.uuid} />)}
      </div>
  )

}
